import { isEqual, uniq } from 'lodash';
import { assign, createMachine } from 'xstate';

import { Prospect, ProspectFilters } from '~/generated/graphql';

import { QueryType } from '../types';
import { fetchProspects } from './client';
import { PROSPECTS_PER_PAGE } from './constants';

type UpdateQueryEvent = {
  type: 'UPDATE_QUERY';
  queryType: QueryType;
  value: Record<string, any>;
};
type UpdateDomainsEvent = {
  type: 'UPDATE_DOMAINS';
  value: string[];
};

// TODO: Add loading of prospect filters
export const machine = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QAUBOB7WAHMBjALgAQAyAlrPgHQA26AhhKQHZQDEE6TYlzAbugGtuAMzD5cAC2ZQ0mHAVgBtAAwBdRKCyZS+Upw0gAHogAsygGyUArAHZzADisBGc84CcAZisAmADQgAT0Qbb3tKDxs3eycI5WjvcxMAXyT-WWw8IjIKGnpGFlYwVAxUSixqOnxhdFQAW0pRcSkWdPl8JTUDLVgdPSYDYwQzS1sHZ1cnTx9-IIR7G2VKExt5s2UnJxtIlLSMDIIScioiktYAJQBRABUzgE0VdSQQbt79J8Hxym8TE2j55TiHm8bhmiHs3kWriBHhhoUmTh2IFamUOOVwnGEpCgAFdUNJWABla4AfQAigBVC53YkAQSuNwAkgAhclXC4PLraXRvUCDVyLZQeCyTb4ecxbGyghCJGyUJy-ZQmNyeGwRNxWRHIg7ZKjopiYnF4gqXACyAHkAGoXMmU6l0xkstkcp4vbn9d6IcxAr4eEweZVudbrEzmKVWZyUeYwxJuGxOWwmBGpJF7Nqo3UYrG4-EEmlW52aLl9AaIHxWSh2dVWczKbyquMmKXmUIV0L2AG+5Tqiya1MonWUPUG7MFInEC4AYSuxOQZzNBOQk6uBeeRZ5Rk9rkonns4Iszh8vqlJmr1iiDgBylG83Mvbk-aOg8zhpzF3HU9pxGIK9dxY90rcbxwnjLZY28cM3EbQJTAsCtVU2WFvCcdt7DvfYskfIcsyNNgABELjHJdP2-ToXTXd1eU9cFwnAqwIk2SZmw8KUvEsSC7HMTiPEcQD7FvZMtQwtFnxHNgADkLgADWnZAaQAcXZUjCx6N0SwA8sYmWQD1XjcwYhY5RZScbwkKsZVwwBJU0LTAcsJfApZwuC0GTNckCRneTFMeZTXgojdpS2Sh1iFE8qxMpCpXA2VgU4ui63lTZrIfHIsFQMAsDoHCCToXgwEJPMvM5FS-0ooZYOvcZ3C8PxoIQJxFWscxYwiL06OQ4yku1R9UvSzLpGy3LWAnGkxInN8f3ItThmsOxHBcKrplq8UwnDP1DNrE9uI1AS+y6lK0oyrKcryolpzEmkTUKsjivXQZRXCZZxV+HSaziKV6pMOUYnMuLxXq1CdvvPaqB6w7+uO1gpOQM0zmXJTVxuvzBmmir5smarIoakzDOcAFvkgzqhIzfVSDqfFhtG8b4d-W7S0FOUoXmTwhUiGrZnjT7-R8H4PGQwMaxsQn0yfEmyYKKGYbh7yEd8tTAycL5wLrZtbA2GwrHeqJKC9NxNkZ7SvSFgcwEMLRUF0AoOC4HgmH4IQbbtsAAFoAEcACs6AELAJsRtSYlgxVgUcCx7GVcDMcWb7og2QzNnVDwjcfTEmHICRIHOAirhpWGfdl-8Yi9Ct7C23Xz0iDXaqiWVQ9rb4kIWVVvBSZMmHQCA4AMQT0yKvPSqd0Naqd8sAxH0f1UFwH0OF2gGGkHvVP-Ew2bBbi5WVRNbHDUImsTnIThqeeSv8pqwkVJU-RrNwmrrKU+I8RqfgSZUu0M-jdiBomReHHDD9pgDT5+JBMUXZr6SlqjYZYSwTKqiVIKZCvxd4gwOn1FgA0wC-yRogbw3pBTgWbACeYyEEiY05ruC8Sp7CPRPIgygsAcpz2ur3Y+gUrx8X+u2KwJ4nC3wVtCAhfMIhxhoVhMWUAMFqSam4Vs3xwxemBJBAe7MtbthCBYWBgoNo0JNmbC2YjGEL1KvVbB24zD+1+A4XmUF2bq3CIBH4CxtJkKbpPGySdmCp0gOI-OSp76RAcO2NWgZl4IFjFI2MnFIgLBDF2BOzcgA */
    context: {
      name: '',
      domains: [],
      personQuery: {},
      companyQuery: {},
      prospects: [],
      selectAll: false,
      selectAllPage: false,
      selections: [],
      deselections: [],
      totalProspects: 0,
      previousTotalCompanies: 0,
      totalCompanies: 0,
      previousTotalProspects: 0,
      perPage: PROSPECTS_PER_PAGE,
      currentPage: 1,
      loadingPage: false,
      prospectFilters: null,
      pageStart: 0,
      pageEnd: PROSPECTS_PER_PAGE,
      totalPages: 1,
      hasNextPage: true,
      hasPreviousPage: false,
    },
    id: 'Prospect List',
    initial: 'loading',
    states: {
      loading: {
        invoke: {
          src: 'fetchProspects',
          id: 'fetchingProspects',
          onError: [
            {
              target: 'error',
            },
          ],
          onDone: [
            {
              target: 'configuring',
              actions: 'setProspects',
            },
          ],
        },
      },

      error: {
        on: {
          RETRY: {
            target: 'loading',
          },
        },
      },

      configuring: {
        on: {
          UPDATE_QUERY: {
            actions: 'updateQuery',
            target: 'refreshing',
          },
          UPDATE_DOMAINS: {
            actions: 'updateDomains',
            target: 'refreshing',
          },
          SAVE: {
            target: 'preparingSave',
          },
          SELECT_PROSPECT: {
            actions: 'selectProspect',
          },
          DESELECT_PROSPECT: {
            actions: 'deselectProspect',
          },
          SELECT_ALL: {
            actions: 'selectAll',
          },
          DESELECT_ALL: {
            actions: 'deselectAll',
          },
          SELECT_ALL_PAGE: {
            actions: 'selectAllPage',
          },
          NEXT_PAGE: {
            actions: 'setNextPage',
            cond: 'hasNextPage',
            target: 'refreshing',
          },
          PREVIOUS_PAGE: {
            actions: 'setPreviousPage',
            cond: 'hasPreviousPage',
            target: 'refreshing',
          },
        },
      },

      refreshing: {
        invoke: {
          src: 'fetchProspects',
          id: 'refreshingProspects',
          onError: [
            {
              target: 'error',
            },
          ],
          onDone: [
            {
              target: 'configuring',
              actions: 'setProspects',
            },
          ],
        },
        on: {
          UPDATE_QUERY: {
            actions: 'updateQuery',
            target: 'refreshing',
          },
          UPDATE_DOMAINS: {
            actions: 'updateDomains',
            target: 'refreshing',
          },
          SELECT_ALL: {
            actions: 'selectAll',
          },
          DESELECT_ALL: {
            actions: 'deselectAll',
          },
        },
      },

      preparingSave: {
        on: {
          SAVE: {
            target: 'saving',
          },
          CANCEL: {
            target: 'configuring',
          },
          SET_NAME: {
            actions: 'setName',
          },
          EXPORT: {
            target: 'confirming',
          },
        },
      },

      saving: {
        invoke: {
          src: 'saving',
          id: 'saving',
        },
      },

      confirming: {
        on: {
          CANCEL: {
            target: 'preparingSave',
          },
          EXPORT: {
            target: 'exporting',
          },
        },
      },

      exporting: {
        invoke: {
          src: 'exporting',
          id: 'invoke-qjakp',
          onDone: [
            {
              target: 'finished',
            },
          ],
        },
      },

      finished: {
        on: {
          RESTART: {
            target: 'loading',
          },
        },
      },
    },
    schema: {
      events: {} as
        | { type: 'RETRY' }
        | UpdateQueryEvent
        | UpdateDomainsEvent
        | { type: 'SAVE' }
        | { type: 'CANCEL' }
        | { type: 'SET_NAME' }
        | { type: 'SELECT_PROSPECT' }
        | { type: 'DESELECT_PROSPECT' }
        | { type: 'EXPORT' }
        | { type: 'RESTART' }
        | { type: 'SELECT_ALL' }
        | { type: 'DESELECT_ALL' }
        | { type: 'SELECT_ALL_PAGE' }
        | { type: 'NEXT_PAGE' }
        | { type: 'PREVIOUS_PAGE' },
      context: {} as {
        name: string;
        domains: string[];
        personQuery: any; // TODO: Type from gql codegen
        companyQuery: any; // TODO: Type from gql codegen
        prospects: Prospect[];
        selections: string[];
        deselections: string[];
        selectAll: boolean;
        selectAllPage: boolean;
        totalProspects: number;
        previousTotalProspects: number;
        totalCompanies: number;
        previousTotalCompanies: number;
        perPage: number;
        currentPage: number;
        pageStart: number;
        pageEnd: number;
        totalPages: number;
        loadingPage: boolean;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        prospectFilters: null | ProspectFilters;
      },
    },
    predictableActionArguments: true,
    preserveActionOrder: true,
  },
  {
    actions: {
      updateDomains: assign((_context, event: UpdateDomainsEvent) => {
        return {
          domains: event.value ?? [],
        };
      }),
      updateQuery: assign((_context, event: UpdateQueryEvent) => {
        if (event.queryType === 'person') {
          return {
            loadingPage: true,
            personQuery: event.value,
          };
        } else if (event.queryType === 'company') {
          return {
            loadingPage: true,
            companyQuery: event.value,
          };
        } else {
          throw new Error('Invalid query type');
        }
      }),
      setName: (_context, _event) => {},
      setNextPage: assign((context) => {
        return {
          loadingPage: true,
          selectAllPage: false,
          currentPage: context.currentPage + 1,
        };
      }),
      setPreviousPage: assign((context) => {
        return {
          loadingPage: true,
          selectAllPage: false,
          currentPage: context.currentPage - 1,
        };
      }),
      selectProspect: assign((context, event: any) => {
        const prospectIds = context.prospects.map((prospect) => prospect.id);

        if (context.selectAll) {
          return {
            selectAllPage: false,
            deselections: context.deselections.filter((id) => id !== event.id),
          };
        } else {
          const selections = uniq([...context.selections, event.id]);

          return {
            selectAllPage: isEqual(prospectIds, selections),
            selections,
          };
        }
      }),
      deselectProspect: assign((context, event: any) => {
        if (context.selectAll) {
          return {
            selectAllPage: false,
            deselections: uniq([...context.deselections, event.id]),
          };
        } else {
          return {
            selectAllPage: false,
            selections: context.selections.filter((id) => id !== event.id),
          };
        }
      }),
      selectAll: assign((_context) => {
        return {
          selectAll: true,
          selections: [],
          deselections: [],
        };
      }),
      deselectAll: assign((_context) => {
        return {
          selectAll: false,
          selectAllPage: false,
          selections: [],
          deselections: [],
        };
      }),
      selectAllPage: assign((context) => {
        const selections = context.prospects.map((prospect) => prospect.id);

        if (context.selectAll) {
          return {
            selectAllPage: false,
            deselections: context.deselections.filter(
              (id) => !selections.includes(id),
            ),
          };
        } else {
          const allSelections = uniq([...context.selections, ...selections]);

          return {
            selectAllPage: true,
            selections: allSelections,
          };
        }
      }),
      // TODO: Properly type this based on gql query
      setProspects: assign((context, event: any) => {
        const totalProspects = event.data.prospects.totalCount;
        const totalCompanies = event.data.prospects.totalCompanies;
        const totalPages = Math.ceil(totalProspects / context.perPage) || 1;

        const currentPage =
          context.currentPage > totalPages ? totalPages : context.currentPage;

        const pageStart = (currentPage - 1) * context.perPage + 1;
        const pageEnd = pageStart + context.perPage - 1;

        return {
          loadingPage: false,
          prospects: event.data.prospects.nodes,
          prospectFilters: event.data.prospectFilters,
          totalProspects,
          previousTotalProspects: context.totalProspects,
          totalCompanies,
          previousTotalCompanies: context.totalCompanies,
          totalPages,
          pageStart: totalProspects === 0 ? 0 : pageStart,
          pageEnd: pageEnd > totalProspects ? totalProspects : pageEnd,
          hasNextPage: context.currentPage < totalPages,
          hasPreviousPage: context.currentPage > 1,
          currentPage,
        };
      }),
    },
    services: {
      fetchProspects,
      saving: async (_context, _event) => {},
      exporting: async (_context, _event) => {},
    },
    guards: {
      hasNextPage: (context) => {
        return context.currentPage < context.totalPages;
      },
      hasPreviousPage: (context) => {
        return context.currentPage > 1;
      },
    },
    delays: {},
  },
);
